import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";
import { useHttpClientDispatchable } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchable";

export const useSeenTipsService = () =>
  useHttpClientDispatchable({
    url: `/tip/seen`,
    method: RequestMethodEnum.PUT,
  });
